import React from "react";
import { styled } from "styled-components";

import { Button, ButtonVariants } from "affinityUI/elements/button";
import { logout, logoutRedirect } from "lib/auth";
import type { CurrentUser } from "lib/auth/types";

async function handleLogoutClick() {
  await logout();
  logoutRedirect();
}

const UserPanel = styled.div`
  display: flex;
  padding: 0.5rem 2rem;
  background: white;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
`;

export const CurrentUserPanel: React.FC<{ currentUser: CurrentUser }> = ({ currentUser }) => {
  return (
    <UserPanel data-testid="current-user-panel">
      <div>
        <strong>{currentUser?.hospital?.name}</strong>
      </div>
      <div>
        <strong>User: </strong>
        {currentUser?.firstName} {currentUser?.lastName}
      </div>
      <div>
        <strong>Role: </strong>
        {currentUser?.role?.name}
      </div>
      <Button variant={ButtonVariants.LINK} onClick={handleLogoutClick}>
        Logout
      </Button>
    </UserPanel>
  );
};
